<template>
  <div class="fixed inset-0 bg-slate-900/60 z-50 flex items-center justify-center p-4" @click.self="$emit('close')" role="dialog" aria-modal="true" :aria-label="$t('送信履歴')">
    <div class="bg-white rounded-q4cl shadow-card-hover w-full max-w-lg border border-q4cl-border max-h-[80vh] flex flex-col">
      <header class="px-5 py-3 border-b border-q4cl-border flex items-center justify-between flex-shrink-0">
        <h3 class="font-bold text-q4cl-primary">
          {{ $t('送信履歴') }}<span v-if="currentTitle"> ({{ $t(currentTitle) }})</span>
        </h3>
        <button class="btn-icon" type="button" @click="$emit('close')" :aria-label="$t('閉じる')"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>
      <div class="flex-1 overflow-y-auto">
        <div v-if="isEmpty" class="p-8 text-center text-sm text-q4cl-muted">
          {{ $t('送信履歴はありません') }}
        </div>
        <!-- 旧版踏襲 (ModalSentHistory.vue:15-25): 現在の qName の履歴のみ、 時刻降順 -->
        <ul v-else class="divide-y divide-q4cl-border">
          <li v-for="item in arrHistory" :key="item.answerId" class="px-5 py-3">
            <div class="text-sm text-q4cl-ink">
              {{ $t('回答番号') }}: <strong class="font-mono">{{ item.answerId }}</strong>
            </div>
            <div class="text-xs text-q4cl-muted mt-0.5">{{ $t('送信時刻') }}: {{ item.time }}</div>
            <div v-if="item.labelFieldVal" class="text-xs text-q4cl-muted mt-0.5">
              {{ $t('識別値') }}: {{ $t(item.labelFieldVal) }}
            </div>
          </li>
        </ul>
      </div>
      <footer class="px-5 py-3 border-t border-q4cl-border flex justify-between flex-shrink-0">
        <button v-if="!isEmpty" type="button" class="btn-secondary text-rose-600 border-rose-200" @click="removeSubmitHistory">{{ $t('送信履歴を消去') }}</button>
        <span v-else></span>
        <button type="button" class="btn-primary" @click="$emit('close')">{{ $t('閉じる') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
/**
 * 旧版 (Q4CL-client_old_version/src/components/ModalSentHistory.vue) 踏襲:
 * - 現在の問診票 (qName) のみの履歴を表示
 * - 時刻降順ソート
 * - 消去は当該 qName のぶんだけ
 * - タイトルには問診票の title (qstDef.title) を括弧書きで併記
 *
 * qName / title は questionnaireStore から読む (props 経由にしないのは deviceStore と同じ疎結合方針)。
 */
export default {
  name: 'ModalSentHistory',
  emits: ['close'],
  setup() {
    const i18n = window.i18nStore;
    const qs = window.questionnaireStore;
    const currentQName = qs?.state?.qName || '';
    const currentTitle = qs?.state?.qstDef?.title || currentQName;

    // 該当 qName の履歴のみ時刻降順で配列化
    function buildArr() {
      const hist = window.deviceStore.getSubmitHistory();
      const grp = hist[currentQName] || {};
      const arr = Object.keys(grp).map((id) => ({
        answerId: grp[id].answerId || id,
        time: grp[id].time || '',
        labelFieldVal: grp[id].labelFieldVal || ''
      }));
      // 時刻文字列は 'YYYY/MM/DD HH:mm' 形式なので lexical で降順ソート OK
      return _.orderBy(arr, ['time'], ['desc']);
    }

    const arrHistory = Vue.ref(buildArr());
    const isEmpty = Vue.computed(() => arrHistory.value.length === 0);

    function removeSubmitHistory() {
      const msg = i18n ? i18n.i18n('送信履歴を消去しますか？') : '送信履歴を消去しますか？';
      if (!confirm(msg)) return;
      window.deviceStore.removeSubmitHistoryForQName(currentQName);
      arrHistory.value = [];
    }

    return { currentTitle, arrHistory, isEmpty, removeSubmitHistory };
  }
};
</script>
